/**
 * Pack size selector for product cards on listing pages.
 * Clicking a pack button just updates the quantity. The Discount Function
 * applies pack pricing automatically based on cart line quantity.
 */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pack-btn-box p[data-qty]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var btnBox = btn.closest('.pack-btn-box');

    btnBox.querySelectorAll('p[data-qty]').forEach(function (p) {
      p.classList.remove('active');
    });
    btn.classList.add('active');

    var productItem = btn.closest('.product-item') || btn.closest('.item-content')?.parentElement;
    if (!productItem) return;

    var packSize = parseInt(btn.getAttribute('data-qty'), 10);
    var qtyInput = productItem.querySelector('.pack-qty-input');
    if (qtyInput) qtyInput.value = packSize;
  }, true);
})();
